import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import {FaIcon} from '../../FaIcon';
import {ClientMemoryApi} from '../../../api/clientMemoryApi';
import {MediaPlanApi} from '../../../api/mediaPlanApi';

const ACTIONABLE_STATUSES = ['OPEN', 'PARTIALLY_APPLIED'];

// Action item del media plan en el Panel (ficha v2, D6/D10): si hay una propuesta abierta,
// interpela — hoy nadie se entera si no entra al tab. El endpoint de propuesta exige
// connection_id, así que primero se resuelve la conexión MEDIA_PLAN activa del cliente (mismo
// encadenado que MediaPlanConnectionsView). Fuera del piloto ambos fetches degradan en silencio.
export function MediaPlanActionItem({clientId}) {
    const {t} = useTranslation();
    const [proposal, setProposal] = useState(null);

    useEffect(() => {
        let cancelled = false;
        ClientMemoryApi.listConnections(clientId, 'MEDIA_PLAN').then((data) => {
            const connections = (data && data.connections) || [];
            const active = connections.find((c) => c.status === 'ACTIVE');
            if (!active || cancelled) return;
            MediaPlanApi.getProposal(clientId, active.id).then((proposalData) => {
                if (cancelled) return;
                const found = proposalData && proposalData.proposal;
                if (found && ACTIONABLE_STATUSES.includes(found.status)) {
                    setProposal(found);
                }
            });
        });
        return () => { cancelled = true; };
    }, [clientId]);

    if (!proposal) return null;

    // Valor exacto del backend: MediaPlanProposalItem.REVIEW_PENDING = 'PENDING_REVIEW'.
    // El conteo separa CAMBIOS (cards de crear/actualizar) de DUDAS (NEEDS_DECISION): la pantalla
    // de la propuesta solo llama "cambios propuestos" a los primeros — si el banner sumara ambos,
    // anunciaría "4 cambios" y la pantalla mostraría "2" (feedback fede 2026-07-18).
    const pendingItems = (proposal.items || []).filter(
        (item) => item.review_status === 'PENDING_REVIEW');
    const pendingChanges = pendingItems.filter(
        (item) => item.action_type !== 'NEEDS_DECISION').length;
    const pendingQuestions = pendingItems.length - pendingChanges;
    const bannerText = pendingChanges > 0
        ? t('control_central.media_plan_pending', {count: pendingChanges})
        : pendingQuestions > 0
            ? t('control_central.media_plan_decisions', {count: pendingQuestions})
            : t('control_central.media_plan_open');

    return (
        <div className="media-plan-action-item">
            <FaIcon iconName="table-cells-large"/>
            <div className="media-plan-action-text">
                <strong>{bannerText}</strong>
            </div>
            <Link className="btn -alt -small" to={`/client/${clientId}/media-plan`}>
                {t('control_central.media_plan_cta')}
            </Link>
        </div>
    );
}
